import { createAsyncThunk } from '@reduxjs/toolkit';
import { Media } from '~/content/types';
import { Upload } from '~/uploads/entities/Upload';
import { selectCurrentOrganizationId } from '~/organizations/selectors';
import { uploadsPreloaded } from '../slice';

export const preloadMedia = createAsyncThunk<
  void,
  { media: Media[]; uploaderId: string }
>('uploads/preloadMedia', ({ media, uploaderId }, { getState, dispatch }) => {
  const organizationId = selectCurrentOrganizationId(getState());

  const uploads = media.map((item) =>
    Upload.newFromMedia(item, {
      trackingId: `media-${item.id}`,
      uploaderId,
      organizationId,
      accountId: 'todo-account-id',
    })
  );

  dispatch(uploadsPreloaded(uploads));
});
